// extracted by mini-css-extract-plugin
module.exports = {"footer":"MutateMid_footer__1nX7n","legacyBtn":"MutateMid_legacyBtn__9ImQM"};